import React from 'react';
import { useRevShare } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
import { RevShareCheckoutSubtitle } from './RevShareCheckoutSubtitle';
import { RevShareCycleSubtitle } from './RevShareCycleSubtitle';
export const RevShareSubtitle = _ref => {
  let {
    FallbackSubtitle,
    preventDefaultWhileLoading = false
  } = _ref;
  const module = useCurrentModule();
  const currentStep = module.internals.hooks.useCurrentStep();
  const cycle = module.SDK.PackagePickerStore.useSelectedCycle() ?? undefined;
  const {
    isLoading: isRevShareLoading,
    getMaxRevShareAmount,
    getRevShareAmountPerCycle
  } = useRevShare();
  const formatPrice = module.SDK.useFormatPrice();
  if (isRevShareLoading && preventDefaultWhileLoading) {
    return null;
  }
  if (currentStep === 'select-cycle') {
    const maxRevShareAmount = getMaxRevShareAmount();
    if (maxRevShareAmount > 0) {
      const formattedAmount = formatPrice(maxRevShareAmount);
      return /*#__PURE__*/React.createElement(RevShareCycleSubtitle, {
        formattedAmount: formattedAmount
      });
    }
  }
  if (currentStep === 'checkout') {
    if (cycle) {
      const revShareAmount = getRevShareAmountPerCycle(cycle);
      if (revShareAmount) {
        const formattedAmount = formatPrice(revShareAmount);
        return /*#__PURE__*/React.createElement(RevShareCheckoutSubtitle, {
          formattedAmount: formattedAmount
        });
      }
    }
  }
  return FallbackSubtitle ?? null;
};
//# sourceMappingURL=RevShareSubtitle.js.map